import React from 'react'

import {
  TagComponent,
  Icon,
  Verified,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

function SubscriberStatus({ productPrice }) {
  return (
    <div className="subscriber-status">
      <div className="subscriber-status__price-row">
        <span className="subscriber-status__free-price">$0</span>
        <span className="subscriber-status__original-price">{productPrice}</span>
        <TagComponent
          type="ghost"
          backColor="brand-primary-20"
          className="subscriber-status__badge"
        >
          <Icon
            svgComponent={Verified}
            size="tiny"
            notSpaced
            className="subscriber-status__badge-icon"
          />
          Included in Subscription
        </TagComponent>
      </div>
    </div>
  )
}

SubscriberStatus.propTypes = {
  productPrice: string.isRequired,
}

export default SubscriberStatus
